import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Doctors.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Doctors data
const doctors = [
  {
    id: 1,
    name: "Dr. Saurabh S. Chavan",
    specialization: "General, GI Laparoscopic Surgeon and Endoscopist",
    experience: "10+ years experience",
    qualifications: "MBBS, MS, FMAS, EFIAGES (General Surgery)",
    image: "/images/doc1.webp",
    detailImage: "/images/saurabh.webp",
  },
  {
    id: 2,
    name: "Dr. Shubhada Bahirat-Chavan",
    specialization: "Gynecologist",
    experience: "12 years experience",
    qualifications: "MBBS MS ,FMAS , FRM (Obstetrics & Gynaecology)",
    image: "/images/doctorx.webp",
    detailImage: "/images/doc2.webp",
  },
];

const Doctors = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  return (
    <div className="doctors-page">
      <h2 className="section-title" data-aos="fade-up">
        Meet Our Experts
      </h2>

      <div className="doctors-grid">
        {doctors.map((doc) => (
          <Link
            key={doc.id}
            to={`/doctors/${doc.id}`}
            className="doctor-card"
            data-aos="fade-up"
          >
            <div className="card-image">
              <img src={doc.image} alt={doc.name} />
              <div className="overlay">
                <button className="view-profile">Know More</button>
              </div>
            </div>
            <div className="card-footer">
              {doc.name}
              <br />
              {doc.qualifications.trim()}
            </div>
          </Link>
        ))}
      </div>

      {/* About Us button below all cards */}
      <Link to="/about" className="about-us-btn">
        About Us
      </Link>
    </div>
  );
};

export default Doctors;
export { doctors };
